import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const PromoPageAccessGuard: CanActivateFn = () => {
  const router = inject(Router);
  const siteConfig = JSON.parse(localStorage.getItem('siteConfiguration') || '{}');
  const isBankIoUser = !!siteConfig.bankIOLicense;
  const hasOriginationLicense = !!siteConfig.originationLicense;

  if (!isBankIoUser || !hasOriginationLicense) {
    return router.parseUrl('/access-denied');
  }
  return true;
};
